import { auth } from '../firebaseConfig';
import { getAuthDownloadUrl } from './firebaseProject';

export async function openAuthenticatedInvoice(invoiceId, format = 'pdf') {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Debes iniciar sesión para descargar la factura.');
  }
  const url = await getAuthDownloadUrl(invoiceId, format, () => user.getIdToken());
  window.open(url, '_blank', 'noopener,noreferrer');
}
